export default __webpack_public_path__ + "static/media/logo.a9117f5c.svg";